<div class="container p-4">
    <div class="card p-5">

        <div class='container'>

            <h3><i style="color:green;" class="fa fa-check-circle"></i> Thank you for confirming</h3>
            <p>Coupon code was activated successfully. place your order now and get direct discount immediately!

            </p>
            <div class="text-center"> <h4>Coupon Code [{{coupon_code}}]</h4></div>

        </div>


    </div>


</div>

